package com.jingfangpai.common.data.type

import com.jingfangpai.common.data.serializer.DateSerializer
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable

@Serializable(with = DateSerializer::class)
actual class Date actual constructor(): Any() {
    @Contextual
    var realDate = kotlin.js.Date();
    actual constructor(date:String) : this() {
        realDate = kotlin.js.Date(date)
    }
    actual constructor(date:Long) : this() {
        realDate = kotlin.js.Date(date)
    }
    constructor(date:kotlin.js.Date) : this() {
        realDate = date
    }
    @JsName("getFullYear")
    actual fun getFullYear():Int{
        return realDate.getFullYear()
    }
    @JsName("getDate")
    actual fun getDate(): Int {
        return realDate.getDate();
    }
    @JsName("getMonth")
    actual fun getMonth():Int {
       return realDate.getMonth()
    }
    @JsName("getTime")
    actual fun getTime():Long {
        return realDate.getTime().toLong()
    }
    @JsName("getHours")
    actual fun getHours():Int {
        return realDate.getHours()
    }
    @JsName("getMinutes")
    actual fun getMinutes():Int {
       return realDate.getMinutes();
    }
    @JsName("move")
    actual fun move(days:Int):Date{
        val newDate = Date()
        newDate.realDate = kotlin.js.Date(this.getTime()+days*24*3600*1000)
        return newDate
    }
    @JsName("toJsDate")
    fun toJsDate():kotlin.js.Date {
        return realDate
    }
    @JsName("toDateString")
    actual fun toDateString():String {
        val month = "${realDate.getMonth() + 1}".padStart(2,'0')
        val date =  "${realDate.getDate()}".padStart(2,'0')
        return "${realDate.getFullYear()}-${month}-${date}"
    }
    @JsName("toEndOfDateTimeString")
    actual fun toEndOfDateTimeString():String {
        val month = "${realDate.getMonth() + 1}".padStart(2,'0')
        val date =  "${realDate.getDate()}".padStart(2,'0')
        return "${realDate.getFullYear()}-${month}-${date} 23:59:59"
    }
    @JsName("toBeginOfDateTimeString")
    actual fun toBeginOfDateTimeString():String {
        val month = "${realDate.getMonth() + 1}".padStart(2,'0')
        val date =  "${realDate.getDate()}".padStart(2,'0')
        return "${realDate.getFullYear()}-${month}-${date} 00:00:00"
    }
    @JsName("lt")
    actual fun lt(date:Date):Boolean{
        return "${this.getFullYear()}${"${this.getMonth()}".padStart(2,'0')}${"${this.getDate()}".padStart(2,'0')}".toInt() < "${date.getFullYear()}${"${date.getMonth()}".padStart(2,'0')}${"${date.getDate()}".padStart(2,'0')}".toInt()
    }
    @JsName("le")
    actual fun le(date:Date):Boolean{
        return !lt(date)
    }

/**
     * 计算年龄
     */

    actual fun calculateAge(birthDay:Date):Int{
         return if (birthDay == null) {
                0
            } else {
                val by: Int = birthDay.getFullYear()
                val bm: Int = birthDay.getMonth() + 1
                val bd: Int = birthDay.getDate()
                val cy: Int = this.getFullYear()
                val cm: Int = this.getMonth() + 1
                val cd: Int = this.getDate()
                var age = cy - by
                if (cm - bm < 0) {
                    --age
                } else if (cm - bm == 0 && cd - bd < 0) {
                    --age
                }
                age = if (age < 0) 0 else age
                age
            }
    }


/**
     * 计算体检年检
     */

    actual fun calculateHealthCheckAge(birthDay:Date):Int{
        return if (birthDay == null) {
            0
        } else {
            this.getFullYear()-birthDay.getFullYear()
        }
    }
}

